import { Component, EventEmitter, Input, OnChanges, OnInit, Output, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { COPY_ACTION, DELETE_ACTION, MAIN_DOMAIN } from '@app/app.constants';

import { TemplateService } from '@app/core/services/template.service';
import { PrivilegeService } from '@app/core/services/privilege.service';

import {
    BoxLevel,
    CardTemplate,
    Character,
    KairosBonus,
    LessonPrivilegeSetting,
    MinifiedBox,
    Privilege
} from '@app/definitions/interfaces';

import { printIcon } from '@app/app.constants';
import { duplicateIcon } from '@app/app.constants';
import { removeIcon } from '@app/app.constants';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-edit-lesson-box',
    templateUrl: './edit-lesson-box.component.html',
    styleUrls: ['./edit-lesson-box.component.scss']
})
export class EditLessonBoxComponent implements OnInit, OnChanges, OnDestroy {
    @Input() public boxLevels: Array<BoxLevel>;
    @Input() public cardIndex: number;
    @Input() public box: MinifiedBox;
    @Input() public lessonID: number;
    @Input() public lessonDate: Date;
    @Input() public privilegeSettings: LessonPrivilegeSetting[];
    @Input() public groupRights = {
        create_lesson: {
            index_title: 5,
            is_access: false
        },
        edit_other_lesson: {
            index_title: 3,
            is_access: false
        },
        change_status_other_lesson: {
            index_title: 6,
            is_access: false
        },
        copy_other_lesson: {
            index_title: 4,
            is_access: false
        },
        delete_other_lesson: {
            index_title: 2,
            is_access: false
        },
        edit_tamplates: {
            index_title: 7,
            is_access: false
        }
    };

    public printIcon = printIcon;
    public duplicateIcon = duplicateIcon;
    public removeIcon = removeIcon;

    public boxLevel: number;
    public boxTitle: number;
    public numberOfCards: number;
    public mainDomain = MAIN_DOMAIN;
    public cardTemplate: CardTemplate;
    public character: Character;
    public privileges: { character: Character; privilege: Privilege }[] = [];
    public activePrivilegeSettings: LessonPrivilegeSetting[];
    public kairosBonus: KairosBonus;

    private destroy$: Subject<boolean> = new Subject<boolean>();
    @Output() public cardAction = new EventEmitter<any>();

    constructor(
        private router: Router,
        private templateService: TemplateService,
        private privilegesService: PrivilegeService
    ) {}

    ngOnDestroy(): void {
        this.destroy$.next(true);
    }

    public ngOnInit(): void {
        this.boxLevel = this.getCurrentBoxLevel();
        this.boxTitle = this.box.title;
        this.numberOfCards = this.box.number_of_cards;
        this.getCharacter();
        this.getKairosBonus();
        this.generatePreview();
        this.fillActivePrivileges();
    }

    public ngOnChanges(): void {
        this.fillActivePrivileges();
    }

    public deleteBoxCard(): void {
        this.cardAction.emit({
            command: DELETE_ACTION,
            cardIndex: this.cardIndex
        });
    }

    public copyBoxCard(event): void {
        if (event) {
            event.stopPropagation();
        }
        this.cardAction.emit({
            command: COPY_ACTION,
            cardIndex: this.cardIndex
        });
    }

    private generatePreview(): void {
        if (this.box.exercises_in_card !== 0 && this.box.files.length !== 0) {
            this.templateService
                .sendTemplateRequestByFilesID(this.box.exercises_in_card, this.box.files)
                .subscribe(resp => {
                    if (!resp.error) {
                        this.cardTemplate = resp.data;
                    }
                });
        }
    }

    private getCharacter(): void {
        if (this.box.sell_character_id) {
            this.privilegesService.getCharacter(this.box.sell_character_id).subscribe(response => {
                this.character = response;
            });
        }
    }

    private getCurrentBoxLevel(): number {
        for (const boxLevel of this.boxLevels) {
            if (this.box.level === boxLevel.id) {
                return boxLevel.level;
            }
        }
    }

    public printBoxCard(): void {
        this.router.navigate(['/teacher/print/box', this.box.id]);
    }

    public editBox(): void {
        this.router.navigate(['/teacher/prepare', this.lessonID, 'edit', 'box', this.box.id]);
    }

    public fillActivePrivileges() {
        this.activePrivilegeSettings = [];
        this.privilegeSettings.forEach(setting => {
            const index = setting.boxes.findIndex(boxID => boxID === this.box.id);
            if (index !== -1) {
                this.activePrivilegeSettings.push(setting);
            }
        });
    }

    private getKairosBonus() {
        this.privilegesService.getKairosBonus(this.box.id).subscribe(resp => {
            this.kairosBonus = resp.data as KairosBonus;
        });
    }
}
